<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout wrap>
            <v-flex sm12 xs12 md12 lg12 grid-list-md>
                <material-card icon="mdi-content-copy" :title="title" :text="text">         
                    <v-container fill-height fluid grid-list-xl>
                        <v-layout wrap>  
                            <v-flex md12 sm12 lg12>
                                <v-btn to="/onboarding/dashboard" >
                                    <v-icon left dark>
                                        mdi-arrow-left-circle
                                    </v-icon>                                    
                                    {{voltar}}
                                </v-btn>                 
                            </v-flex>

                            <v-flex md4 sm6 lg3>
                                <vagas-processadas />
                            </v-flex>

                            <v-flex md4 sm6 lg3>
                                <tempo-inclusao />
                            </v-flex>                 
                                                       
                            <v-flex md4 sm6 lg3>
                                <tempo-alteracao />
                            </v-flex>      
                                                   
                            <v-flex md4 sm6 lg3>
                                <tempo-aprovacao />
                            </v-flex>    
                            
                            <v-flex md4 sm6 lg3>
                                <tempo-pendente-aprovacao />
                            </v-flex>   
                            
                            <v-flex md4 sm6 lg3>
                                <sem-data-contratacao />
                            </v-flex>
                        </v-layout>

                        <v-layout wrap>  
                            <v-flex md12 sm12 lg4>
                                <vagas-por-empresa />
                            </v-flex>  

                            <v-flex md12 sm12 lg4>
                                <vagas-por-divisao />
                            </v-flex>

                            <v-flex md12 sm12 lg4>
                                <vagas-por-localidade />
                            </v-flex>   

                            <v-flex md12 sm12 lg4>
                                <vagas-por-cargo />
                            </v-flex>       
                            
                            <v-flex md12 sm12 lg4>
                                <vagas-por-centro-custo />
                            </v-flex>     

                            <v-flex md12 sm12 lg12>
                                <v-btn to="/onboarding/dashboard" >
                                    <v-icon left dark>
                                        mdi-arrow-left-circle
                                    </v-icon>                                    
                                    {{voltar}}
                                </v-btn>                 
                            </v-flex>
                        </v-layout>
                    </v-container>                         
                </material-card>
            </v-flex>
        </v-layout>            
    </v-container>
</template>

<script>
import FormMixin from '@/mixin/form'
import DateMixin from '@/mixin/date'

import VagasProcessadas from './Stats/VagasProcessadas'
import TempoInclusao from './Stats/TempoInclusao'
import TempoAlteracao from './Stats/TempoAlteracao'
import TempoAprovacao from './Stats/TempoAprovacao'
import TempoPendenteAprovacao from './Stats/TempoPendenteAprovacao'
import SemDataContratacao from './Stats/SemDataContratacao'
import VagasPorEmpresa from './Stats/VagasPorEmpresa'
import VagasPorDivisao from './Stats/VagasPorDivisao'
import VagasPorLocalidade from './Stats/VagasPorLocalidade'
import VagasPorCargo from './Stats/VagasPorCargo'
import VagasPorCentroCusto from './Stats/VagasPorCentroCusto'

import PaisApi from '@/api/workspace/corporativo/pais'

export default {
    components: {
        "vagas-processadas": VagasProcessadas,
        "tempo-inclusao": TempoInclusao,
        "tempo-alteracao": TempoAlteracao,
        "tempo-aprovacao": TempoAprovacao,
        "tempo-pendente-aprovacao": TempoPendenteAprovacao,
        "sem-data-contratacao": SemDataContratacao,
        "vagas-por-empresa": VagasPorEmpresa,
        "vagas-por-divisao": VagasPorDivisao,
        "vagas-por-localidade": VagasPorLocalidade,
        "vagas-por-cargo": VagasPorCargo,
        "vagas-por-centro-custo": VagasPorCentroCusto
    },
    mixins: [ FormMixin, DateMixin ],  
    data () {
        return { 
            dataInicial: null, 
            dataFinal: null,   
            pais: null            
        }
    },
    computed: {  
        title () {
            return this.$t('Views.Onboarding.Dashboard.Resultado.dashboard')     
        },
        text () {
            let dates = this.$moment(this.tranformEpoch2Date(this.dataInicial)).format('L');
            dates =  `${dates} ~ ${this.$moment(this.tranformEpoch2Date(this.dataFinal)).format('L')}`; 

            if(this.pais != null){
                return `${this.pais.nome}: ${dates}` ;
            }

            return dates;
        },
        voltar(){
            return this.$t('Views.Onboarding.Dashboard.Resultado.voltar')            
        },                           
    },
    created(){
        this.dataInicial = this.$route.params.dataInicial;
        this.dataFinal = this.$route.params.dataFinal;
    },
    async mounted(){     
        const loading = this.showLoading();

        const pais = await PaisApi.listar().catch(erro => this.showSnackbarError(erro.error));            

        if(pais.success) {
            const filtro = pais.data.filter(p => p.id == this.$route.params.idPais);
            if((filtro || []).length > 0)
                this.pais = filtro[0];
        }
        else {                        
            this.showSnackbarError(pais.error);
            throw new Error(pais.error[0].userMessage);
        }     
        
        loading.close();
    },    
    methods:{         
    }
}
</script>

<style lang="scss"  >
@import "../../../styles/material-dashboard/variables";
// .building .v-offset .v-card{
//     background-color: red !important;
// }
 

.v-card--material-stats {
  display: flex;
  flex-wrap: wrap;
  position: relative;

  .v-offset {
    display: inline-block;
    flex: 0 1;
    margin-top: 0;
    margin-left: 0;
    margin-right: auto;
    margin-bottom: 0 !important;
    max-width: auto;
    padding: 0 16px 0;

    .v-card{
        line-height: 55px !important;
    }

    .dark-gray{
        background-color: #3d3d3d !important;
    }

    .light-gray{
        background-color: #b1b1b1 !important;
    }

    .blue{
        background-color: #1d5cf6 !important;
    }   

    .svg-icon {
        width: 85px;
        margin-left: 5px;
        .v-icon__svg{
            height: 40px !important;
            width: 40px !important;
        }
    }      
  } 

  .v-card {
    border-radius: 4px;
    flex: 0 1 auto;
  }

  .v-card__text {
    display: inline-block;
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
  }

  .v-card__actions {
    flex: 1 0 100%;
  }
}
</style>
